import React from 'react'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation-mobile-overlay.is-active {
  animation: none;
}
.navigation-brand:hover {
  transform: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <nav className="navigation-wrapper">
        <div className="navigation-container navigation-thq-navigation-container-elm">
          <div className="navigation-links-group navigation-left">
            <a href="#">
              <div className="navigation-link">
                <span>Promotions</span>
              </div>
            </a>
            <a href="#">
              <div className="navigation-link">
                <span>Games</span>
              </div>
            </a>
          </div>
          <img
            alt={props.imageAlt}
            src={props.imageSrc}
            className="navigation-image"
          />
          <a href="/">
            <div
              aria-label="ANGKA138 Home"
              className="navigation-thq-navigation-brand-elm1 navigation-brand"
            ></div>
          </a>
          <div className="navigation-links-group navigation-right">
            <a href="#">
              <div className="navigation-link">
                <span>VIP Club</span>
              </div>
            </a>
            <a href="#">
              <div className="navigation-link">
                <span>Support</span>
              </div>
            </a>
          </div>
          <div className="navigation-mobile-actions">
            <button
              id="mobileMenuOpen"
              aria-label="Open Menu"
              aria-expanded="false"
              className="navigation-toggle"
            >
              <svg
                fill="none"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                stroke="currentColor"
                viewBox="0 0 24 24"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 6h16M4 12h16M4 18h16"></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <a href="/">
            <div aria-label="ANGKA138 Home" className="navigation-brand">
              <span className="section-title navigation-brand-text">
                ANGKA138
              </span>
            </div>
          </a>
          <button
            id="mobileMenuClose"
            aria-label="Close Menu"
            className="navigation-close"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-5.5-3.5l-5 5m0-5l5 5"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-mobile-content">
          <div className="navigation-mobile-links">
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Promotions</span>
              </div>
            </a>
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Games</span>
              </div>
            </a>
            <a href="#">
              <div className="navigation-mobile-link">
                <span>VIP Club</span>
              </div>
            </a>
            <a href="#">
              <div className="navigation-mobile-link">
                <span>Support</span>
              </div>
            </a>
          </div>
          <div className="navigation-mobile-ctas">
            <a href="/registration">
              <div className="btn-lg btn navigation-cta-full btn-secondary">
                <span>DAFTAR</span>
              </div>
            </a>
            <a href="#">
              <div className="btn-outline btn-lg btn navigation-cta-full">
                <span>LOGIN</span>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
        @keyframes slideIn {from {transform: translateX(100%);}
to {transform: translateX(0);}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const mobileMenuOpen = document.getElementById("mobileMenuOpen")
  const mobileMenuClose = document.getElementById("mobileMenuClose")
  const mobileOverlay = document.getElementById("mobileOverlay")

  if (mobileMenuOpen && mobileOverlay) {
    mobileMenuOpen.addEventListener("click", () => {
      mobileOverlay.classList.add("is-active")
      document.body.style.overflow = "hidden"
      mobileMenuOpen.setAttribute("aria-expanded", "true")
    })
  }

  if (mobileMenuClose && mobileOverlay) {
    mobileMenuClose.addEventListener("click", () => {
      mobileOverlay.classList.remove("is-active")
      document.body.style.overflow = ""
      mobileMenuOpen.setAttribute("aria-expanded", "false")
    })
  }

  const mobileLinks = document.querySelectorAll(".navigation-mobile-link")
  mobileLinks.forEach((link) => {
    link.addEventListener("click", () => {
      mobileOverlay.classList.remove("is-active")
      document.body.style.overflow = ""
      mobileMenuOpen.setAttribute("aria-expanded", "false")
    })
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Navigation.defaultProps = {
  imageSrc: '/hd_restoration_result_image-200h.png',
  imageAlt: 'image',
}

Navigation.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
}

export default Navigation
